import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient'; // API 클라이언트
import { BaseResponse } from '../UtilsInterface';
import { NoticesApiResponse, NoticesData } from '../NoticeInterfaces';

// 공지사항 서비스 정의
const NoticeService = {
  // 공지사항 목록 조회
  getNoticesList: async (
    page: number,
    size: number,
    keyword?: string
  ): Promise<NoticesApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_notices_list(page, size, keyword)
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 목록 조회 실패:', error);
      throw error;
    }
  },

  // 공지사항 상세 조회
  getNoticeDetail: async (
    noticeId: string
  ): Promise<BaseResponse<NoticesData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_notice_detail(noticeId)
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 상세 조회 실패:', error);
      throw error;
    }
  },
};

export default NoticeService;
